import i18n from "@/i18n.ts";
import {
  ApiPermission,
  ApiRoleShort,
  EmployeeFieldPermission,
  PermissionType,
  PrincipalType,
  RoleType,
  Rule,
  RuleApplySignType,
  RuleConditionType,
  RuleEmploymentDurationCalcMode,
  RuleEmploymentDurationPresetType,
} from "@/types/role.types.ts";
import { ModalProps, SelectItem } from "@skailer-com/uikit";
import { z } from "zod";

export interface PageRolesProps {
  tab?: keyof PageRolesTab;
}

export interface PageRolesTab {
  list: string;
  employees: string;
}

export const mockRole = {
  id: 0,
  title: "",
  type: RoleType.custom,
  principal_type: PrincipalType.employee,
  description: "",
  assign_to: [],
  apply_to: [],
  employees_count: 0,
  api_permissions: {
    [ApiPermission.settings_departments]: PermissionType.none,
    [ApiPermission.settings_divisions]: PermissionType.none,
    [ApiPermission.settings_positions_levels]: PermissionType.none,
    [ApiPermission.settings_roles_permissions]: PermissionType.none,
    [ApiPermission.settings_organization]: PermissionType.none,
    [ApiPermission.settings_integrations]: PermissionType.none,
    [ApiPermission.settings_pipelines]: PermissionType.none,
    [ApiPermission.settings_data_protection]: PermissionType.none,
    [ApiPermission.manage_holidays]: PermissionType.none,
    [ApiPermission.add_employees]: PermissionType.none,
    [ApiPermission.dismiss_employees]: PermissionType.none,
    [ApiPermission.delete_employees]: PermissionType.none,
    [ApiPermission.ban_employees]: PermissionType.none,
    [ApiPermission.impersonate_employees]: PermissionType.none,
    [ApiPermission.recruiting_module]: PermissionType.none,
    [ApiPermission.show_all_jobs]: PermissionType.none,
    [ApiPermission.manage_jobs]: PermissionType.none,
    [ApiPermission.show_jobs_salaries]: PermissionType.none,
    [ApiPermission.show_all_candidates]: PermissionType.none,
    [ApiPermission.manage_candidates]: PermissionType.none,
    [ApiPermission.delete_candidates]: PermissionType.none,
    [ApiPermission.show_candidates_salaries]: PermissionType.none,
    [ApiPermission.see_original_resume]: PermissionType.none,
    [ApiPermission.settings_sources]: PermissionType.none,
    [ApiPermission.settings_templates]: PermissionType.none,
    [ApiPermission.settings_candidate_disqualification_reasons]: PermissionType.none,
    [ApiPermission.settings_job_archiving_reasons]: PermissionType.none,
    [ApiPermission.settings_locations]: PermissionType.none,
    [ApiPermission.settings_legal_entities]: PermissionType.none,
    [ApiPermission.delete_all_comments]: PermissionType.none,
    [ApiPermission.reporting_recruiting_stage_flow]: PermissionType.none,
    [ApiPermission.reporting_recruiting_source_efficiency]: PermissionType.none,
    [ApiPermission.reporting_recruiting_closing_time]: PermissionType.none,
    [ApiPermission.reporting_recruiting_disqualification_reasons]: PermissionType.none,
    [ApiPermission.reporting_export]: PermissionType.none,
    [ApiPermission.see_notes]: PermissionType.none,
    [ApiPermission.manage_leave_policies]: PermissionType.none,
    [ApiPermission.manage_approval_policy]: PermissionType.none,
    [ApiPermission.approve_and_reject_leaves]: PermissionType.none,
    [ApiPermission.see_employee_directory]: PermissionType.none,
    [ApiPermission.employees_search]: PermissionType.none,
    [ApiPermission.manage_teams]: PermissionType.none,
    [ApiPermission.settings_employment_types]: PermissionType.none,
    [ApiPermission.settings_employment_contracts]: PermissionType.none,
    [ApiPermission.settings_compensation_change_reasons]: PermissionType.none,
    [ApiPermission.settings_compensation_types]: PermissionType.none,
    [ApiPermission.settings_probation_policies]: PermissionType.none,
    [ApiPermission.settings_hiring_flows]: PermissionType.none,
    [ApiPermission.settings_work_patterns]: PermissionType.none,
    [ApiPermission.settings_security]: PermissionType.none,
    [ApiPermission.audit_log_read]: PermissionType.none,
    [ApiPermission.settings_organization_links]: PermissionType.none,
    [ApiPermission.settings_document_folders]: PermissionType.none,
    [ApiPermission.settings_api_users]: PermissionType.none,
    [ApiPermission.settings_webhooks]: PermissionType.none,
    [ApiPermission.reporting_employee_headcount]: PermissionType.none,
    [ApiPermission.reporting_employee_salary]: PermissionType.none,
    [ApiPermission.reporting_employee_total_cost]: PermissionType.none,
    [ApiPermission.reporting_leave_balance]: PermissionType.none,
    [ApiPermission.reporting_leave_used]: PermissionType.none,
    [ApiPermission.reporting_employee_retention]: PermissionType.none,
    [ApiPermission.reporting_people_analytics]: PermissionType.none,
    [ApiPermission.manage_hiring_plan]: PermissionType.none,
    [ApiPermission.manage_offers]: PermissionType.none,
    [ApiPermission.show_offer_salary]: PermissionType.none,
    [ApiPermission.news_manage_channels]: PermissionType.none,
    [ApiPermission.news_manage_posts]: PermissionType.none,
    [ApiPermission.news_delete_all_comments]: PermissionType.none,
    [ApiPermission.ats_manage_scorecards]: PermissionType.none,
    [ApiPermission.manage_career_sites]: PermissionType.none,
    [ApiPermission.manage_custom_fields]: PermissionType.none,
    [ApiPermission.surveys_module]: PermissionType.none,
    [ApiPermission.surveys_create]: PermissionType.none,
    [ApiPermission.surveys_manage_all]: PermissionType.none,
    [ApiPermission.survey_templates]: PermissionType.none,
    [ApiPermission.form_scales]: PermissionType.view,
    [ApiPermission.performance_reviews_module]: PermissionType.none,
    [ApiPermission.performance_reviews_create]: PermissionType.none,
    [ApiPermission.performance_reviews_manage_all]: PermissionType.none,
    [ApiPermission.performance_review_templates]: PermissionType.none,
    [ApiPermission.workflow_module]: PermissionType.none,
    [ApiPermission.workflows_create]: PermissionType.none,
    [ApiPermission.workflows_executions]: PermissionType.none,
    [ApiPermission.workflows_manage_all]: PermissionType.none,
    [ApiPermission.workflows_manual_run]: PermissionType.none,
    [ApiPermission.goals_module]: PermissionType.none,
    [ApiPermission.goals_company_manage]: PermissionType.none,
    [ApiPermission.goals_department_manage_all]: PermissionType.none,
    [ApiPermission.goals_department_manage_own]: PermissionType.none,
    [ApiPermission.goals_team_manage_all]: PermissionType.none,
    [ApiPermission.goals_team_manage_own]: PermissionType.none,
    [ApiPermission.tasks_module]: PermissionType.none,
    [ApiPermission.tasks_create]: PermissionType.none,
    [ApiPermission.tasks_manage_all]: PermissionType.none,

    [ApiPermission.clocking_module]: PermissionType.none,

    [ApiPermission.ai_assistant_module]: PermissionType.none,

    [ApiPermission.esign_manage_templates]: PermissionType.none,
    [ApiPermission.esign_download_report]: PermissionType.none,
    [ApiPermission.esign_request]: PermissionType.none,

    [ApiPermission.settings_recognitions]: PermissionType.none,
    [ApiPermission.recognitions_mass_gift]: PermissionType.none,

    [ApiPermission.data_import]: PermissionType.none,
  },
  employee_field_permissions: {
    [EmployeeFieldPermission.employee_lifecycle_status]: PermissionType.none,
    [EmployeeFieldPermission.employee_last_activity_date]: PermissionType.none,
    [EmployeeFieldPermission.employee_portal_access]: PermissionType.none,

    [EmployeeFieldPermission.employee_name]: PermissionType.view,
    [EmployeeFieldPermission.employee_name_display]: PermissionType.edit,
    [EmployeeFieldPermission.employee_name_pronunciation]: PermissionType.view,
    [EmployeeFieldPermission.employee_hired_on]: PermissionType.none,
    [EmployeeFieldPermission.employee_email]: PermissionType.none,
    [EmployeeFieldPermission.employee_email_personal]: PermissionType.none,
    [EmployeeFieldPermission.employee_phone]: PermissionType.none,
    [EmployeeFieldPermission.employee_phone_personal]: PermissionType.none,
    [EmployeeFieldPermission.employee_slack]: PermissionType.none,
    [EmployeeFieldPermission.employee_gender]: PermissionType.none,
    [EmployeeFieldPermission.employee_date_birth]: PermissionType.none,
    [EmployeeFieldPermission.employee_date_birth_display]: PermissionType.none,
    [EmployeeFieldPermission.employee_avatar]: PermissionType.none,
    [EmployeeFieldPermission.employee_background]: PermissionType.none,
    [EmployeeFieldPermission.employee_time_off]: PermissionType.none,
    [EmployeeFieldPermission.employee_timezone]: PermissionType.none,
    [EmployeeFieldPermission.employee_goals]: PermissionType.none,
    [EmployeeFieldPermission.employee_notes]: PermissionType.none,

    [EmployeeFieldPermission.employee_number]: PermissionType.none,
    [EmployeeFieldPermission.employee_address_address_line_1]: PermissionType.none,
    [EmployeeFieldPermission.employee_address_address_line_2]: PermissionType.none,
    [EmployeeFieldPermission.employee_address_zip_code]: PermissionType.none,
    [EmployeeFieldPermission.employee_address_country]: PermissionType.none,
    [EmployeeFieldPermission.employee_address_state]: PermissionType.none,
    [EmployeeFieldPermission.employee_address_city]: PermissionType.none,

    [EmployeeFieldPermission.manage_employee_position]: PermissionType.none,
    [EmployeeFieldPermission.employee_positions_history]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_changed_by]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_job_title]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_job_track]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_job_grade]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_job_salary]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_date]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_reporting_to]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_division]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_department]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_location]: PermissionType.none,
    [EmployeeFieldPermission.employee_position_comment]: PermissionType.none,

    [EmployeeFieldPermission.manage_employee_employment]: PermissionType.none,
    [EmployeeFieldPermission.employee_employments_history]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_changed_by]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_date]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_legal_entity]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_employment_type]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_contract]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_work_pattern]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_probation]: PermissionType.none,
    [EmployeeFieldPermission.employee_employment_comment]: PermissionType.none,

    [EmployeeFieldPermission.manage_employee_termination]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_date]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_last_working_date]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_leave_type]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_reason]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_replacement_employee]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_eligible_for_rehire]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_comment]: PermissionType.none,
    [EmployeeFieldPermission.employee_termination_changed_by]: PermissionType.none,

    [EmployeeFieldPermission.manage_employee_compensation]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensations_history]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_changed_by]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_date]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_change_reason]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_comment]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_base_salary_gross]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_base_salary_net]: PermissionType.none,
    [EmployeeFieldPermission.employee_additional_compensation]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_lines]: PermissionType.none,
    [EmployeeFieldPermission.employee_compensation_total_cost]: PermissionType.none,
    /** @deprecated The backend keeps this key for compatibility with legacy role data. */
    [EmployeeFieldPermission.employee_compensation_off_payroll]: PermissionType.none,

    [EmployeeFieldPermission.clocking_entries]: PermissionType.none,

    [EmployeeFieldPermission.see_organization_structure]: PermissionType.none,
    [EmployeeFieldPermission.see_departments_structure]: PermissionType.none,
    [EmployeeFieldPermission.access_to_leave_timeline]: PermissionType.none,
    [EmployeeFieldPermission.employee_recognitions]: PermissionType.none,
  },
};

export interface RuleEditModalProps extends ModalProps {
  popupTitle?: string;
  forceSign?: RuleApplySignType;
  rule?: Rule;
  conditionTypes: SelectItem[];
  onModified: (rule: Rule) => void;
  onDelete: () => void;
  isSingleSelect?: boolean;
  singleSelectConditionTypes?: RuleConditionType[];
  multiSelectConditionTypes?: RuleConditionType[];
  canDelete?: boolean;
  applyLabel?: string;
  signItems?: SelectItem[];
  showEmployeeCountPreview?: boolean;
}

export const EditRuleSchemaObject = z
  .object({
    condition_type: z.enum(RuleConditionType),
    sign: z.enum(RuleApplySignType),
    // Matches API list[int | str]: CF option ids are numbers; strings come from JSON/legacy.
    condition_ids: z.array(z.union([z.number(), z.string()])),
    value_ids: z.array(z.union([z.number(), z.string()])),
    condition_entities: z.array(z.any()).optional(),
    value_entities: z.array(z.any()).optional(),
    employment_duration_calc_mode: z
      .enum(RuleEmploymentDurationCalcMode)
      .nullable()
      .default(RuleEmploymentDurationCalcMode.by_period),
    employment_duration_operator: z.string().nullable().default(null),
    employment_duration_preset: z.enum(RuleEmploymentDurationPresetType).nullable().default(null),
    employment_duration_date_value: z.string().nullable().default(null),
  })
  .superRefine((data, ctx) => {
    if (data.condition_type === RuleConditionType.employment_duration) {
      if (data.employment_duration_operator == null || data.employment_duration_operator === "") {
        ctx.addIssue({
          code: "custom",
          message: i18n.t("errors:field_required"),
          path: ["employment_duration_operator"],
        });
      }

      if (
        data.employment_duration_calc_mode === RuleEmploymentDurationCalcMode.specific_date &&
        (data.employment_duration_date_value == null ||
          data.employment_duration_date_value.trim() === "")
      ) {
        ctx.addIssue({
          code: "custom",
          message: i18n.t("errors:field_required"),
          path: ["employment_duration_date_value"],
        });
      }
    }
  });

export type EditRuleSchema = z.infer<typeof EditRuleSchemaObject>;

export const getRoleTitle = (role: ApiRoleShort) => {
  if (role.type == RoleType.myself) return i18n.t("core:role_type_myself");
  else if (role.type == RoleType.all_employees) return i18n.t("core:role_type_all_employees");
  else if (role.type == RoleType.team_lead) return i18n.t("core:team_leads");
  else if (role.type == RoleType.manager) return i18n.t("core:managers");
  else if (role.type == RoleType.admin) return i18n.t("core:rule_admins");
  else return role.title;
};

export const getRoleDescription = (role: ApiRoleShort) => {
  if (role.type == RoleType.myself) return i18n.t("core:role_type_myself_description");
  else if (role.type == RoleType.all_employees)
    return i18n.t("core:role_type_all_employees_description");
  else if (role.type == RoleType.team_lead) return i18n.t("core:role_type_team_leads");
  else if (role.type == RoleType.manager) return i18n.t("core:role_type_manager");
  else if (role.type == RoleType.admin) return i18n.t("core:role_type_admin");
  else return role.description;
};
